<template>
  <div>
    <section class="no-print">
      <v-row align="center" justify="space-between" no-gutters class="mb-2">
        <v-col cols="12" sm="6"> </v-col>
      </v-row>
    </section>
    <section v-if="deliverySlip">
      <v-card flat>
        <v-card-text>
          <DeliverySlipViewerHeader
            :delivery-slip="deliverySlip"
          ></DeliverySlipViewerHeader>
        </v-card-text>
        <v-card-text :class="{ 'dense-table': $vuetify.breakpoint.xsOnly }">
          <DeliverySlipViewerGrid
            :items="deliverySlip.delivery_slip_products"
            :delivery-slip="deliverySlip"
          ></DeliverySlipViewerGrid>
        </v-card-text>
        <v-card-text>
          <v-textarea
            filled
            label="Commentaires"
            class="no-before"
            v-model="deliverySlip.comments"
            :readonly="deliverySlip.is_closed"
          ></v-textarea>
        </v-card-text>
        <v-card-text class="no-print" v-if="!deliverySlip.is_closed">
          <v-row
            align="center"
            justify="space-between"
            no-gutters
            v-if="prevRoute !== 'DeliverySlipCreator'"
          >
            <v-btn v-if="!$vuetify.breakpoint.xsOnly" @click="save" outlined>
              <v-icon small left>fa-save</v-icon>
              Enregistrer sans compléter
            </v-btn>
            <v-btn
              :block="$vuetify.breakpoint.xsOnly"
              @click="saveAndClose"
              color="success"
            >
              <v-icon small left>fa-clipboard-check</v-icon>
              Compléter la commande
            </v-btn>
            <v-btn
              class="mt-3"
              v-if="$vuetify.breakpoint.xsOnly"
              :block="$vuetify.breakpoint.xsOnly"
              outlined
              @click="save"
            >
              <v-icon small left>fa-save</v-icon>
              Enregistrer sans compléter
            </v-btn>
          </v-row>
          <v-row v-else align="center" justify="space-between" no-gutters>
            <v-btn
              class="mt-3"
              :block="$vuetify.breakpoint.xsOnly"
              outlined
              @click="save"
            >
              <v-icon small left>fa-save</v-icon>
              Enregistrer sans compléter
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </section>
  </div>
</template>

<script>
import { api } from "@/api";
import {
  DeliverySlipViewerGrid,
  DeliverySlipViewerHeader
} from "../components";
import { mapGetters } from "vuex";
import { mappers } from "@/mappers";
import moment from "moment";
export default {
  name: "DeliverySlipViewer",
  components: {
    DeliverySlipViewerGrid,
    DeliverySlipViewerHeader
  },
  props: {
    id: {
      required: true
    }
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.prevRoute = from.name;
      await vm.getData();
    });
  },
  async beforeRouteUpdate() {
    await this.getData();
  },
  computed: {
    ...mapGetters(["getProducts", "getSuppliers"])
  },
  data() {
    return {
      deliverySlip: undefined,
      prevRoute: ""
    };
  },
  methods: {
    async getData() {
      try {
        this.$store.dispatch("slo");
        await Promise.all([
          this.$store.dispatch("loadSuppliers"),
          this.$store.dispatch("loadProducts")
        ]);
        this.deliverySlip = await api.retrieveDeliverySlip(this.id);
        this.deliverySlip.supplier = this.getSuppliers.find(
          x => x.id_fournisseur == this.deliverySlip.fk_supplier
        );
        this.deliverySlip.created = moment(this.deliverySlip.created).format(
          "LLL"
        );
        this.deliverySlip.delivery_slip_products = this.deliverySlip.delivery_slip_products.map(
          x => {
            let product = this.getProducts.find(p => p.id === x.fk_product);
            if (product) {
              delete product.id;
              return {
                ...x,
                ...product,
                quantity_ordered: Number(x.quantity_ordered),
                quantity_received: Number(x.quantity_received),
                origin_quantity_received: Number(x.quantity_received),
                origin_quantity_ordered: Number(x.quantity_ordered),
                mapped_unit: this.getUnit(product)
              };
            } else {
              return {
                ...x,
                quantity_ordered: Number(x.quantity_ordered),
                quantity_received: Number(x.quantity_received),
                origin_quantity_received: Number(x.quantity_received),
                origin_quantity_ordered: Number(x.quantity_ordered)
              };
            }
          }
        );
      } finally {
        this.$store.dispatch("elo");
      }
    },
    async saveAndClose() {
      const allow = await this.$dialog.confirm({
        text:
          "Voulez-vous vraiment compléter cette commande? Vous ne pourrez plus éditer les quantités recus par après.",
        title: ""
      });
      if (allow) {
        try {
          this.$store.dispatch("slo");
          const data = {
            ...this.deliverySlip,
            is_receive: true,
            is_closed: true
          };
          const tasks = this.transactionTasks();
          tasks.push(api.patchDeliverySlip(this.id, data));
          await Promise.all(tasks);
          if (this.prevRoute === "DeliverySlipCreator") {
            this.$router.push({ name: "StatisticsIndex" });
          } else {
            this.$router.push({ name: this.prevRoute });
          }
        } finally {
          this.$store.dispatch("elo");
        }
      }
    },
    async save() {
      try {
        this.$store.dispatch("slo");
        const data = {
          ...this.deliverySlip
        };
        const tasks = this.transactionTasks();
        tasks.push(api.patchDeliverySlip(this.id, data));
        await Promise.all(tasks);
        if (this.prevRoute === "DeliverySlipCreator") {
          this.$router.push({ name: "StatisticsIndex" });
        } else {
          this.$router.push({ name: this.prevRoute });
        }
      } finally {
        this.$store.dispatch("elo");
      }
    },
    transactionTasks() {
      const tasks = [];
      this.deliverySlip.delivery_slip_products.forEach(x => {
        if (
          x.quantity_received !== x.origin_quantity_received ||
          x.quantity_ordered !== x.origin_quantity_ordered
        ) {
          const d = {
            ...x
          };
          tasks.push(api.patchDeliverySlipProduct(x.id, d));
          const orderQty = x.quantity_received - x.origin_quantity_received;
          let invQty = orderQty;
          if (x.data) {
            invQty = mappers.productOrderToInv(orderQty, x.data);
          }
          const r = {
            fk_product: x.fk_product,
            store: x.store,
            date: moment().format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ"),
            quantity: invQty,
            transaction_type: 2
          };
          tasks.push(api.postInventoryTransaction(r));
        }
      });
      return tasks;
    },
    getUnit(item) {
      if (item.data) {
        if (item.data.use_order_quantity) {
          return item.data.unite_mesure_order;
        } else {
          return item.data.unite_mesure_inventory;
        }
      } else {
        return "";
      }
    }
  }
};
</script>

<style></style>
